var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card, Text } from '@philips-internal/oswald-ui-components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { FluidBalanceAPI } from '.';
import moment from 'moment';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './fluid-balance.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let FluidBalanceCard = class FluidBalanceCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick, dailyHydricBalanceAnalyses, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dailyHydricBalanceAnalyses
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderDailyContent() {
        const { dailyHydricBalanceAnalyses } = this.props;
        return (React.createElement(React.Fragment, null, dailyHydricBalanceAnalyses?.map((hydric, index) => (React.createElement(React.Fragment, null,
            dailyHydricBalanceAnalyses.length === (index + 1) &&
                React.createElement("div", { className: "c-component-separator" }),
            React.createElement("div", { className: "c-fluid-balance-card__header" },
                React.createElement("div", { className: "c-fluid-balance-card__hour" },
                    React.createElement(Text, { className: "c-text-hour", value: hydric.expedient, bold: true })),
                dailyHydricBalanceAnalyses.length !== (index + 1) &&
                    React.createElement("div", { className: "c-fluid-balance-card__hour" },
                        React.createElement(Text, { className: "c-text-hour", value: moment(hydric.dailyBalanceDate).format('L'), bold: true }))),
            React.createElement("div", { className: "c-fluid-balance-card__dynamic-data", key: index },
                React.createElement("div", { className: "c-fluid-balance-card-content-item" },
                    React.createElement("div", { className: "c-fluid-balance-card-content-label" },
                        React.createElement(Text, { className: "c-text-label", value: MessageService.translate('tws.gain-ml') })),
                    React.createElement("div", { className: "c-fluid-balance-card-content-value" },
                        React.createElement(Text, { className: "c-text-value", value: Number(hydric.gainQuantity).toLocaleString(undefined, { minimumFractionDigits: 2 }) }))),
                React.createElement("div", { className: "c-fluid-balance-card-content-item" },
                    React.createElement("div", { className: "c-fluid-balance-card-content-label" },
                        React.createElement(Text, { className: "c-text-label", value: MessageService.translate('tws.loss-ml') })),
                    React.createElement("div", { className: "c-fluid-balance-card-content-value" },
                        React.createElement(Text, { className: "c-text-value", value: Number(hydric.lossQuantity).toLocaleString(undefined, { minimumFractionDigits: 2 }) }))),
                React.createElement("div", { className: "c-fluid-balance-card-content-item" },
                    React.createElement("div", { className: "c-fluid-balance-card-content-label" },
                        React.createElement(Text, { className: "c-text-label", value: MessageService.translate('tws.balance-ml') })),
                    React.createElement("div", { className: "c-fluid-balance-card-content-value" },
                        React.createElement(Text, { className: "c-text-value", value: Number(hydric.balanceQuantity).toLocaleString(undefined, { minimumFractionDigits: 2 }) })))))))));
    }
    render() {
        const { dailyHydricBalanceAnalyses } = this.props;
        return (React.createElement(Card, { className: "c-fluid-balance-card c-hidden-tap", uuid: generateUUID(), key: `${dailyHydricBalanceAnalyses[0].gainQuantity} + ${dailyHydricBalanceAnalyses[0].dailyBalanceDate}`, width: 12, selectionType: SelectionType.SINGLE },
            React.createElement("div", { className: "c-fluid-balance-card__wrapper" }, this.renderDailyContent())));
    }
};
FluidBalanceCard = __decorate([
    AwesomeComponent({ api: FluidBalanceAPI, type: ComponentType.DATA_DISPLAY })
], FluidBalanceCard);
export default FluidBalanceCard;
//# sourceMappingURL=fluid-balance-card.js.map